/* eslint-disable import/prefer-default-export */
export const eu = {
  translation: {
    title: 'Kopia baimendu elektronikoa balioztatu',
    desc:'Sartu CSVa (Egiaztapen Kode Segurua) eta sakatu Balioztatu botoia notario-dokumentuaren kopia baimendu elektronikoaren benetakotasuna eta osotasuna egiaztatzeko, baita ondorengo aldaketa juridikoen eta beste tresna publiko batzuekiko koordinazioaren oharrak ezagutzeko ere.',
    placeholderCSV:'CSV kodea',
    validateButton: 'Balioztatu',
    backButton:'Itzuli',
    okButton:'Onartu',
    cancelButton:'Utzi',
    closeButton:'Itxi',
    actionsButton:'Ekintzak',
    downloadButton:'Deskargatu',
    head:{
      title: 'NOTARIO-AGINTARITZAREN EGOITZA ELEKTRONIKOA',
    },
    footer:{
      legalNotice: 'Arau Legalak',
      privacyPolicy: 'Pribatutasun Politika',
      accessibility: 'Irisgarritasuna',
      cookiesPolicy: 'Cookieen politika',
      supportedBrowsers: 'Nabigatzaile onartuenak',
    },
    modalsupportedbrowsers:{
      other: 'PC, Mac, mugikor edo tablet erabiliz sar zaitezke.',
    },
    actions: {
      helpButton:'Laguntza ikusi',
      validateSignature:'Sinadura balioztatu',
      download:'Deskargatu',
      downloadCombined: 'Bateratuta deskargatu'
    },
    modalAyuda:{
      title:'Laguntza',
      guide:'Hemen atal honekin lotutako gida deskarga dezakezu',
      section1: 'Sinaduraren balioa egiaztatzea Egoitza Elektroniko Notarialaren bidez',
      desc1: 'Notarioaren sinadura elektroniko kualifikatuaren balioa egiaztatzeko notario-dokumentuan, egin klik <strong>Ekintzak</strong> botoian eta hautatu <strong>Sinadura balioztatu</strong>.',
      section2: 'Sinaduraren balioa egiaztatzea Adobe Acrobat Reader erabiliz',
      desc2: 'Notarioaren sinadura elektroniko kualifikatuaren balioa egiaztatzeko notario-dokumentuan, egin klik <strong>Ekintzak</strong> botoian eta hautatu <strong>Deskargatu</strong>. Ondoren, ireki dokumentua Adobe Acrobat Reader-rekin eta egin klik alboko menuan dagoen lumaren ikonoan. <br /><br /> Goitibeherako zerrendan sinaduraren balioa egiaztatu eta haren xehetasunak aztertu ahal izango dituzu.',
      section3: 'Sinaduraren balioa egiaztatzea VALIDe erabiliz',
      desc3: 'Notarioaren sinadura elektroniko kualifikatuaren balioa egiaztatzeko notario-dokumentuan, egin klik <strong>Ekintzak</strong> botoian eta hautatu <strong>Deskargatu</strong>. Ondoren, erabili',
      linkText: 'VALIDe plataforma publikoa',
    },
    modalCopia:{
      title:'Kopia baimendu elektronikoa',
    },
    modalErrorServicio:{
      desc: 'Ez dago sartu duzun CSV kodearekin lotutako kopia baimendu elektronikorik. Mesedez, egiaztatu kodea eta saiatu berriro.',
      contactSupport: 'Arazoek jarraitzen badute, laguntza-zerbitzuarekin harremanetan jar zaitezke.',
    },
    modalAdvertenciaDescarga:{
      title:'Oharra',
      desc:'<strong>Aldaketa juridikoei</strong> eta beste tresna publiko batzuekiko koordinazioari buruzko oharrak <strong>kopiaren jaulkipenaren ondoren egin badira, ez dira eskuragarri egongo deskargatuko duzun dokumentuan.</strong> Kopiaren jaulkipen-agirian bakarrik agertzen dira.',
    },
    modalErrorGenerico:{
      desc:'Arazo bat gertatu da. Saiatu berriro.',
    },
    modalErrorValidacion:{
      title:'Errorea sinadura balioztatzean.',
      desc:'Ezin izan da dokumentuaren sinadura balioztatu. Saiatu berriro edo jarri harremanetan laguntza-zerbitzuarekin.',
    },
    modalManuales:{
      name:'Izena',
    },
    modalValidacionFirma:{
      title:'Sinadura balioztatu',
      firmaNotario:'NOTARIOAREN SINADURA KUALIFIKATUA:',
      fechaFirma:'SINADURAREN DATA:',
      fechaValidacion:'BALIOZKOTZEAREN DATA:',
      estadoFirma:'SINADURAREN EGOERA:',
      validacionFirma:'Notariotzaren Kontseilu Orokorraren sinadura elektronikoaren baliozkotzea',
      validada:'Balioztatuta',
      noValidada:'Balioztatuta gabe',
      contenido:'Dokumentuaren edukia',
      alterado:'aldatua',
      noAlterado:'aldatu gabe',
      certificadoFirmante:'Sinatzailearen ziurtagiria',
      caducado:'iraungita',
      noCaducado:'iraungi gabe',
      revocado:'indargabetuta',
      noRevocado:'indargabetu gabe',
      certificadoCa:'konfiantzazko ziurtapen-agintaritza batek (CA) jaulkia',
      noCertificadoCa:'ez da konfiantzazko CA batek jaulkia',
    },
  },
};
